"use strict";

const InputBaseControlComponent = require("../InputBaseControlComponent");
const _ = require("lodash");

class InputBaseActionControlComponent extends InputBaseControlComponent {
    /**
     * @schema.name Input Base Action Control
     *
     * @schema.configuration.active.name active
     * @schema.configuration.active.type boolean
     * @schema.configuration.active.default false
     * @schema.configuration.active.required false
     *
     * @schema.configuration.label.name label
     * @schema.configuration.label.type string
     * @schema.configuration.label.default ""
     * @schema.configuration.label.required true
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._active = _.get(configOptions, "active", false);
        this._label = _.get(configOptions, "label", "");
    }

    /*******************************************/
    /* START PRIVATE METHODS */
    /*******************************************/

    /**
     * Pass the DOM click event up from the renderer as a 'UserClick' Component event
     * @param {event} event - The DOM event that triggered the click
     * @private
     */
    _triggerUserClick(event) {
        this.emit("UserClick", event);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setActive.name setActive
     * @schema.methods.setActive.description Sets the active state of the control and returns an instance of the control for chainability
     * @schema.methods.setActive.returns Instance of the control
     * @schema.methods.setActive.parameters.newVal.name newVal
     * @schema.methods.setActive.parameters.newVal.description The new active state
     * @schema.methods.setActive.parameters.newVal.type boolean
     */
    setActive(newVal) {
        this._active = newVal;
        this.emit("Active", this._active);
        return this;
    }
    /**
     * @schema.methods.isActive.name isActive
     * @schema.methods.isActive.description Returns the active state
     * @schema.methods.isActive.returns boolean
     */
    isActive() {
        return this._active;
    }
    get active() {
        return this.isActive();
    }
    set active(newVal) {
        return this.setActive(newVal);
    }

    /**
     * @schema.methods.setLabel.name setLabel
     * @schema.methods.setLabel.description Sets the display text of the control and returns an instance of the control for chainability
     * @schema.methods.setLabel.returns Instance of the control
     * @schema.methods.setLabel.parameters.newVal.name newVal
     * @schema.methods.setLabel.parameters.newVal.description The new display text
     * @schema.methods.setLabel.parameters.newVal.type string
     */
    setLabel(newVal) {
        this._label = newVal;
        this.emit("Label", this._label);
        return this;
    }
    /**
     * @schema.methods.getLabel.name getLabel
     * @schema.methods.getLabel.description Returns the display text of the control
     * @schema.methods.getLabel.returns string
     */
    getLabel() {
        return this._label;
    }
    get label() {
        return this.getLabel();
    }
    set label(newVal) {
        return this.setLabel(newVal);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = InputBaseActionControlComponent;
